import "./static/index.css";
import React from "react";
import { Header, Body, Footer, LowerBody } from "./components";
export default function View() {
  return (
    <div className="rootContainer">
      <Header />
      <Body />
      <LowerBody />

      <Footer />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Home/view.jsx